// ─────────────────────────────────────────────────────────────────────────────
// FUENTE UNICA del tamaño de la base. Antes esta cifra estaba escrita a mano en
// cinco sitios y decia tres cosas distintas (808,000+, 1.2M y 3,900+); se
// unifico aqui, y es el unico sitio donde se cambia.
//
// Lo que dice ahora esta CONTADO en la base de produccion el 20-10-2026:
// 212.924 sellers visibles (sin tombstone y sin filas sombra) — 28.825 de
// Clay, 183.973 de SmartScout y 126 del pipeline. Hasta entonces la web decia
// 808.000+, una cifra que nadie habia comprobado y que era casi cuatro veces lo
// que hay; Tony eligio publicar la real (19-10-2026).
//
// "213K" es el redondeo. La forma larga dice "212,000+" y no "213,000+"
// porque esa seria mentira por 76 sellers. El "across Amazon and Walmart" de
// PROOF_STATS se fue con el 808K: de Walmart no hay ni una fila (en /discovery
// sale como "Soon").
//
// Es una constante, no se lee de la base: crece con cada importacion de
// SmartScout y hay que recontarla a mano cuando cambie lo bastante. Con
//   SELECT count(*) FROM sellers WHERE tombstoned_at IS NULL AND duplicate_of IS NULL;
// ─────────────────────────────────────────────────────────────────────────────
export const SELLER_BASE = {
  /** Para prosa y titulares: "212,000+ sellers". */
  display: "212,000+",
  /** Para etiquetas cortas y eyebrows: "213K sellers". */
  compact: "213K",
  /** Para el contador animado de PROOF_STATS. */
  value: 213,
  suffix: "K",
} as const;

export interface ProofStat {
  /** Numeric portion that animates from 0 (e.g. 98, 30, 72, 1.2). */
  value: number;
  /** Suffix that stays static (e.g. "%", "d", "h", "M"). */
  suffix: string;
  /** Number of decimal places to render during count-up. */
  decimals?: number;
  /** Two-line label shown beneath the number. */
  label: [string, string];
}

export const PROOF_STATS: ProofStat[] = [
  {
    value: 98,
    suffix: "%",
    label: ["Email accuracy", "or we replace, no questions"],
  },
  {
    value: 30,
    suffix: "d",
    label: ["Maximum data age", "re-verified continuously"],
  },
  {
    value: 72,
    suffix: "h",
    label: ["From brief to delivery", "custom-built for your ICP"],
  },
  {
    value: SELLER_BASE.value,
    suffix: SELLER_BASE.suffix,
    label: ["Sellers in our base", "selling on Amazon US"],
  },
];
